export enum AppointmentStatuses {
    Confirmed = "CONFIRMED",
    Declined = "DECLINED"
}